import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { getAndSanitize } from "./shared/utils/sanitization";

// Get saved language preference
const savedLanguage = getAndSanitize("appLanguage");

// Language detector options - prioritize our custom storage key
const languageDetectorOptions = {
  order: ["localStorage", "navigator", "htmlTag"],
  lookupLocalStorage: "appLanguage", // Match the key used in settings
  caches: ["localStorage"],
};

// Define the namespaces based on the actual JSON files in the locales directory
const namespaces = [
  "analytics",
  "clientFinancialHub",
  "common",
  "dashboard",
  "floatingControls",
  "navBar",
  "operations",
  "panelSelector",
  "requestsPanel",
  "settings",
  "superAdmin",
  "support",
  "table",
  "translation",
  "users",
  "validation",
  "wallet",
  "welcomeModal",
  "loadRequest"
];

i18n
  .use(Backend)
  .use(new LanguageDetector(null, languageDetectorOptions))
  .use(initReactI18next)
  .init({
    fallbackLng: "es",
    // Use saved language if available, otherwise default to Spanish
    lng: savedLanguage || "es",
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    ns: namespaces, // Define namespaces to load
    defaultNS: "translation", // Changed to use 'common' as default namespace
    fallbackNS: namespaces, // Use all namespaces as fallback
    returnObjects: true,
    nsSeparator: false, // Disable namespace separator
    keySeparator: ".", // Ensure dots in keys are properly handled
    load: "currentOnly",
  });

// Apply the saved language if it exists
if (savedLanguage) {
  i18n.changeLanguage(savedLanguage);
} else {
  // Only force Spanish if no saved preference exists
  i18n.changeLanguage("es");
}

// Preload all namespaces for the current language
Promise.all(
  namespaces.map((namespace) => {
    return i18n.loadNamespaces(namespace);
  })
).catch((error) => {
  console.error("Error loading namespaces:", error);
});

// Add resource bundles for missing namespaces
namespaces.forEach((namespace) => {
  if (!i18n.hasResourceBundle(i18n.language, namespace)) {
    i18n.addResourceBundle(i18n.language, namespace, {});
  }
});

export default i18n;